import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzTableComponent, NzTableModule } from 'ng-zorro-antd/table';
import { CommonModule } from '@angular/common';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { TableColumn } from '../../interfaces/utilidades/tableColumn.interface';
import { TagComponent } from '../tag/tag.component';

@Component({
  selector: 'app-tabla',
  templateUrl: './tabla.component.html',
  styleUrls: ['./tabla.component.css'],
  standalone: true,
  imports: [
    FormsModule,
    NzTableComponent,
    CommonModule,
    NzPaginationModule,
    NzIconModule,
    NzTableModule,
    NzButtonComponent,
    NzTagModule,
    TagComponent
  ]
})
export class TablaComponent {
  @Input() columns: TableColumn[] = [];
  @Input() data: any[] = [];
  @Input() searchable: boolean = false;
  @Input() showCheckButton: boolean = true;
  @Input() showDeleteButton: boolean = true;
  @Input() showEditButton: boolean = true;
  @Input() showActionsColumn: boolean = true;

  searchTerm: string = '';
  pageSize: number = 8;
  pageIndex: number = 1;

  get filteredData(): any[] {
    if (!this.searchTerm) return this.paginateData(this.data);

    const filtered = this.data.filter((item) =>
      Object.values(item).some((value) =>
        value?.toString().toLowerCase().includes(this.searchTerm.toLowerCase())
      )
    );

    return this.paginateData(filtered);
  }

  private paginateData(data: any[]): any[] {
    const start = (this.pageIndex - 1) * this.pageSize;
    const end = this.pageIndex * this.pageSize;
    return data.slice(start, end);
  }

  onPageChange(index: number): void {
    this.pageIndex = index;
  }

  getValue(row: any, propertyPath: string[]): any {
    return propertyPath.reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : null), row);
  }

  @Output() edit = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();

  onEdit(row: any): void {
    this.edit.emit(row);
  }

  onDelete(row: any): void {
    this.delete.emit(row);
  }

  checkItem(item: any) {
    console.log('Aceptar item', item);
  }

  get length(): number {
    return this.data.length;
  }

  getRowNumber(index: number): number {
    return (this.pageIndex - 1) * this.pageSize + index + 1;
  }
}
